import { createActionGroup, emptyProps } from '@ngrx/store';

export const PurchaseCreditsPageActions = createActionGroup({
  source: 'Purchase Credits Page',
  events: {
    Enter: emptyProps(),
  },
});
